export function orderBy<TClass, TProp>(collection: TClass[], sortingFunction: (item: TClass) => TProp): TClass[] {
    const sortedCollection = collection.sort((a, b) => {
        const valueA = sortingFunction(a);
        const valueB = sortingFunction(b);

        if (valueA === valueB) {
            return 0;
        }

        return valueA < valueB ? -1 : 1;
    });

    return sortedCollection;
}

export function orderByDesc<TClass, TProp>(collection: TClass[], sortingFunction: (item: TClass) => TProp): TClass[] {
    const sortedCollection = collection.sort((a, b) => {
        const valueA = sortingFunction(a);
        const valueB = sortingFunction(b);

        if (valueA === valueB) {
            return 0;
        }

        return valueA > valueB ? -1 : 1;
    });

    return sortedCollection;
}

export function groupBy<T>(array: T[], keySelector: (item: T) => string): Map<string, T[]> {
    return array.reduce((groups, item) => {
      const key = keySelector(item);
      if (!groups.has(key)) {
        groups.set(key, []);
      }
      groups.get(key)!.push(item);
      return groups;
    }, new Map<string, T[]>());
  }
  
  export function maxBy<TClass, TProp>(array: TClass[], selector: (item: TClass) => TProp): TClass | null {
    if (array.length === 0) {
      return null;
    }
  
    let maxItem = array[0];
    let maxValue = selector(maxItem);
  
    for (let i = 1; i < array.length; i++) {
      const currentItem = array[i];
      const currentValue = selector(currentItem);
  
      if (currentValue > maxValue) {
        maxItem = currentItem;
        maxValue = currentValue;
      }
    }
  
    return maxItem;
  }
  
  export function minBy<TClass, TProp>(array: TClass[], selector: (item: TClass) => TProp): TClass | null {
    if (array.length === 0) {
      return null;
    }
  
    let minItem = array[0];
    let minValue = selector(minItem);
  
    for (let i = 1; i < array.length; i++) {
      const currentItem = array[i];
      const currentValue = selector(currentItem);
  
      if (currentValue < minValue) {
        minItem = currentItem;
        minValue = currentValue;
      }
    }
  
    return minItem;
  }
  
  export function sumBy<T>(array: T[], selector: (item: T) => number): number {
    return array.reduce((sum, item) => sum + selector(item), 0);
  }
  
  export function count<T>(array: T[], selector: (item: T) => boolean): number {
    if (array.length === 0) {
      return 0;
    }
  
    let count = 0;
  
    for (let i = 0; i < array.length; i++) {
      if (selector(array[i])) {
        count++;
      }
    }
  
    return count;
  }